var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fixed-dialog',{attrs:{"size":"small","centered":""}},[_c('portal-gun-svg',{staticClass:"icon"}),_c('h2',[_vm._v("Aw, jeez")]),_c('p',[_vm._v("Something went wrong.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }